import styled, { css } from 'styled-components';
import { TableVariant } from '../types';
export const BodyCell = styled.td `
  grid-auto-rows: min-content;
  border-spacing: 0;

  ${({ $hasAction, $variant }) => $hasAction &&
    $variant === TableVariant.Grid &&
    css `
      &:not(:nth-last-child(-n + 2)) {
        border-right: 1px solid ${({ theme }) => theme.secondary.blendToBackground(200)};
      }
    `}

  ${({ $hasAction, $variant }) => !$hasAction &&
    $variant === TableVariant.Grid &&
    css `
      &:not(:last-child) {
        border-right: 1px solid ${({ theme }) => theme.secondary.blendToBackground(200)};
      }
    `}

  ${({ $isStickyLeft, $stickyLeft, $variant }) => $isStickyLeft &&
    css `
      position: sticky;
      left: ${$stickyLeft}px;
      z-index: 2;
      background-color: ${({ theme }) => $variant === TableVariant.List ? `var(--table-row-background-color, ${theme.background})` : theme.background};

      ${$variant === TableVariant.List &&
        css `
        background-color: var(--table-row-background-color, ${({ theme }) => theme.background});

        &:after {
          content: '';
          position: absolute;
          right: -12px;
          top: 0;
          bottom: 0;
          width: 12px;
          pointer-events: none;
          background: linear-gradient(
            to right,
            var(--table-row-background-color, ${({ theme }) => theme.background}) 0px,
            transparent 12px
          );
        }
      `}
    `}

  ${({ $isStickyRight, $stickyRight, $variant }) => $isStickyRight &&
    css `
      position: sticky;
      right: ${$stickyRight}px;
      border-left: 1px solid ${({ theme }) => theme.secondary.blendToBackground(200)};
      border-right: 0;
      z-index: 2;
      background-color: ${({ theme }) => $variant === TableVariant.List ? `var(--table-row-background-color, ${theme.background})` : theme.background};

      ${$variant === TableVariant.List &&
        css `
        border-left: none;
        background-color: var(--table-row-background-color, ${({ theme }) => theme.background});

        &:before {
          content: '';
          position: absolute;
          left: -12px;
          top: 0;
          bottom: 0;
          width: 12px;
          pointer-events: none;
          background: linear-gradient(
            to left,
            var(--table-row-background-color, ${({ theme }) => theme.background}) 0px,
            transparent 12px
          );
        }
      `}
    `}
`;
//# sourceMappingURL=BodyCell.js.map